// src/pages/expense/cafe/geumnaraeDraftConfig.js
// ✅ 전 사업 확산 [5] — 카페인 금나래점의 businessConfig. 가산/독산과 동일한 패턴.
// 템플릿 14종은 DocumentTypeSelector.jsx의 "expense_draft-CAFE_INN_금나래" 목록과
// expenseTemplates.js의 geumnarae_* 정의를 그대로 재사용.
import { makeExpenseDraftConfig } from "../_shared/expenseDraftConfig";
import VendorPanel from "../_shared/VendorPanel";
import ExpenseItemPanel from "../_shared/ExpenseItemPanel";
import SalaryPanel from "./SalaryPanel";

// ── 14종 — Intl.Collator("ko") 정렬 검증 완료(DocumentTypeSelector.jsx와 동일 순서) ──
const TEMPLATES = [
  { code: "geumnarae_gas", label: "가스" },
  { code: "geumnarae_payroll", label: "급여지급" },
  { code: "geumnarae_holiday_gift", label: "명절격려품" },
  { code: "geumnarae_vat", label: "부가세" },
  { code: "geumnarae_social_insurance", label: "사회보험료" },
  { code: "geumnarae_goods", label: "상품구매" },
  { code: "geumnarae_supplies", label: "소모품구매" },
  { code: "geumnarae_water", label: "수도" },
  { code: "geumnarae_credit_card", label: "신용카드결제" },
  { code: "geumnarae_withholding_tax", label: "원천세" },
  { code: "geumnarae_internet", label: "인터넷·전화요금" },
  { code: "geumnarae_ingredient", label: "재료구매" },
  { code: "geumnarae_electric", label: "전기" },
  { code: "geumnarae_pos_rental", label: "포스임대료" },
];

// ✅ CafeGeumnaraeExpense 실측(51건) 근거 기본값. 데이터 근거가 없는 항목(명절격려품/
// 소모품구매/수도)은 빈 값으로 둔다(자유 입력).
const CATEGORY_ITEM_FIELD_DEFAULTS = {
  geumnarae_ingredient: { category_name: "금나래점 재료비", item_name: "", field_name: "구입" },
  geumnarae_goods: { category_name: "상품매입비", item_name: "", field_name: "구입" },
  geumnarae_pos_rental: { category_name: "사무관리비", item_name: "포스 임대료", field_name: "납부" },
  geumnarae_internet: { category_name: "공공운영비", item_name: "인터넷 및 전화 요금", field_name: "납부" },
  geumnarae_credit_card: { category_name: "(정산 용도)수수료 합계", item_name: "(정산 용도)수수료 합계", field_name: "정산" },
  geumnarae_payroll: { category_name: "급여", item_name: "카페인 금나래점 급여", field_name: "지급" },
  geumnarae_social_insurance: { category_name: "연금부담금 등", item_name: "사회보험료", field_name: "납부" },
  geumnarae_electric: { category_name: "공공운영비", item_name: "전기요금(전기료)", field_name: "납부" },
  geumnarae_gas: { category_name: "공공운영비", item_name: "가스요금", field_name: "납부" },
  geumnarae_withholding_tax: { category_name: "예수금", item_name: "원천세", field_name: "납부" },
  geumnarae_vat: { category_name: "공공운영비", item_name: "1기 예정 고지 부가세", field_name: "납부" },
};

const SALARY_PANEL_TEMPLATES = ["geumnarae_payroll"];
const GENERIC_TABLE_PANEL_TEMPLATES = [
  "geumnarae_pos_rental", "geumnarae_credit_card", "geumnarae_social_insurance",
  "geumnarae_withholding_tax", "geumnarae_holiday_gift",
];

const geumnaraeDraftConfig = makeExpenseDraftConfig({
  namespace: "cafe-geumnarae-draft",
  category: "CAFE_INN_금나래",
  businessLabel: "카페인 금나래점",
  // ✅ (구) 페이지가 실제로 쓰는 CafeGeumnaraeExpense.draft_no 접두어와 정확히
  // 일치(DB 실측: 기존 51건 전부 "금천일자리(주)CAFE_INN 금나래점지출").
  draftNoPrefix: "금천일자리(주)CAFE_INN 금나래점지출",
  dataApiBase: "/expense/cafe/geumnarae/",
  combinedCreateApi: "/expense/cafe/geumnarae/draft/",
  newRoutePath: "/expense/cafe/geumnarae/draft/new",
  listRoutePath: "/expense/cafe/geumnarae/draft/list",
  previewRoutePath: "/expense/cafe/geumnarae/draft/preview",
  templates: TEMPLATES,
  categoryItemFieldDefaults: CATEGORY_ITEM_FIELD_DEFAULTS,
  itemPanelTemplates: [],
  salaryPanelTemplates: SALARY_PANEL_TEMPLATES,
  genericTablePanelTemplates: GENERIC_TABLE_PANEL_TEMPLATES,
  VendorPanel,
  ExpenseItemPanel,
  SalaryPanel,
});

export default geumnaraeDraftConfig;
